import styles from "./AppPromo.module.scss";
import appsImg from "./img/apps.png";
import { FormattedMessage, useIntl } from "react-intl";
import BaseLinkOrButton from "../../../../common/core-ui/BaseLinkOrButton.tsx";
import { clsx } from "clsx";
import { useState } from "react";
import { useBrandLoaderData } from "../../../root/rootLoader.ts";
import QrCodeDialogSwitcher from "../../actions/qrcode/QrCodeDialogSwitcher.tsx";

export default function AppPromo({ className }: { className?: string }) {
  const intl = useIntl();
  const brand = useBrandLoaderData();
  const [isQrDialogOpen, setIsQrDialogOpen] = useState(false);

  return (
    <div className={clsx(styles.box, className)}>
      <img
        src={appsImg}
        alt={intl.formatMessage({ defaultMessage: "Mobile Apps" })}
      />
      <div className={styles.text}>
        <h3 className={styles.title}>
          <FormattedMessage
            defaultMessage="Download the {appName} App"
            values={{ appName: brand.DownloadOffline.appName }}
          />
        </h3>
        <FormattedMessage
          defaultMessage="Read or listen on the go with the {appName} native apps. 100% offline access."
          values={{ appName: brand.DownloadOffline.appName }}
          tagName="div"
        />
        <BaseLinkOrButton
          className={clsx("vst-button-pill", "vst-button-variant-outline")}
          aria-label={intl.formatMessage({
            defaultMessage: "Learn More About the Bookshelf App",
          })}
          onClick={() => setIsQrDialogOpen(true)}
        >
          <FormattedMessage defaultMessage="Learn More" />
        </BaseLinkOrButton>
      </div>
      {isQrDialogOpen && (
        <QrCodeDialogSwitcher onRequestClose={() => setIsQrDialogOpen(false)} />
      )}
    </div>
  );
}
